"use strict";

import WMTSCapabilities from 'ol/format/WMTSCapabilities';

/**
 * @classdesc
 * Abstrakte Wrapperklasse für WMS Capabilities-Dokumente.
 *
 * @class
 * @extends Object
 * @memberof gc.gis.GCWmsCapabilities
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.format.OLWmtsCapabilities = function() {

};

/**
 * @param {string} data
 * @return {gc.gis.format.GCWmtsCapabilities}
 */
gc.gis.format.OLWmtsCapabilities.prototype.read = function(data)
{
    const parser = new WMTSCapabilities();
    const capabilities = parser.read(data);
    return this.readImpl(capabilities);
};

/**
 * @param {WMTSCapabilities} capabilities
 * @return {gc.gis.format.GCWmtsCapabilities}
 */
gc.gis.format.OLWmtsCapabilities.prototype.readImpl = function(capabilities)
{
    const version = capabilities.version;
    const parsedCapabilities = new gc.gis.format.GCWmtsCapabilities(capabilities);

    parsedCapabilities.version = version;
    this._readServiceIdentification(capabilities, parsedCapabilities);
    this._readLayerList(capabilities, parsedCapabilities);

    return parsedCapabilities;
};

/**
 * @private
 * @param {WMTSCapabilities} sourceCapabilities
 * @param {gc.gis.format.GCWmtsCapabilities} targetCapabilities
 */
gc.gis.format.OLWmtsCapabilities.prototype._readServiceIdentification = function(sourceCapabilities, targetCapabilities)
{
    if (sourceCapabilities.ServiceIdentification)
    {
        targetCapabilities.title = sourceCapabilities.ServiceIdentification.Title;
        targetCapabilities.abstract = sourceCapabilities.ServiceIdentification.Abstract;
        targetCapabilities.accessConstraints = sourceCapabilities.ServiceIdentification.AccessConstraints;
        targetCapabilities.fees = sourceCapabilities.ServiceIdentification.Fees;
    }
};

/**
 * @private
 * @param {WMTSCapabilities} sourceCapabilities
 * @param {gc.gis.format.GCWmtsCapabilities} targetCapabilities
 */
gc.gis.format.OLWmtsCapabilities.prototype._readLayerList = function(sourceCapabilities, targetCapabilities)
{
    if (sourceCapabilities.Contents && sourceCapabilities.Contents.Layer)
    {
        const sourceLayerList = sourceCapabilities.Contents.Layer;
        for (let i = 0, ii = sourceLayerList.length; i < ii; i++)
        {
            const parsedCapabilitiesLayer = this._readLayer(sourceLayerList[i]);
            targetCapabilities.layers.push(parsedCapabilitiesLayer);
        }
    }
};

/**
 * @private
 * @param {Object} sourceLayer
 */
gc.gis.format.OLWmtsCapabilities.prototype._readLayer = function(sourceLayer)
{
    const parsedLayer = new gc.gis.format.GCWmtsCapabilitiesLayer(sourceLayer);

    parsedLayer.identifier = sourceLayer.Identifier;
    parsedLayer.abstract = sourceLayer.Abstract;
    parsedLayer.title = sourceLayer.Title;
    parsedLayer.formats = sourceLayer.Format;
    parsedLayer.styles = sourceLayer.Style;
    parsedLayer.wgs84BoundingBox = sourceLayer.WGS84BoundingBox;

    for (let i = 0, ii = sourceLayer.TileMatrixSetLink; i < ii; i++)
    {
        parsedLayer.tileMatrixSets.push(sourceLayer.TileMatrixSetLink[i].TileMatrixSet);
    }

    return parsedLayer;
};